
import { Route, Routes } from 'react-router-dom'

import { Add, List } from './components'

export const ModuleRoutes = () => (
  <>
    <List />
    <Routes>
      <Route path="add" element={<Add />} />
    </Routes>
  </>

)
